import { createSelector } from 'reselect';

import { generateSchemaForFields } from '../utils/fields';

import getRegisterProfileFields from './getRegisterProfileFields';
import getConfig from './getConfig';
import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';

const { getInternationalMobileAllowed, getMobileRegexWhiteList } = OrderingSelectors;
const { MOBILE_REGEX_INT, MOBILE_REGEX_AU } = OrderingConstants;

export default createSelector(
  [getRegisterProfileFields, getConfig, getInternationalMobileAllowed, getMobileRegexWhiteList],
  (registrationFields, config, internationalMobileAllowed, mobileRegexWhiteList) => {
    const { hidden, visible } = registrationFields!;

    const newConfig: ConfigState = {
      ...config,
      internationalMobileAllowed,
      mobileRegexInt: MOBILE_REGEX_INT,
      mobileRegexAU: MOBILE_REGEX_AU,
      mobileRegexWhiteList,
    };
    return {
      visible: generateSchemaForFields(visible, newConfig),
      hidden: generateSchemaForFields(hidden, newConfig),
    };
  },
);
